var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M780.07 457.82L334.62 19.41C321.73 6.32 306.17 0 287.5 0c-37.79 0-67.57 30.25-67.57 68.18a68.91 68.91 0 0020.89 49.21l402.77 394.16-402.77 394.61c-13.33 13.54-20.89 30.25-20.89 49.66 0 37.93 29.78 68.18 67.57 68.18 18.23 0 34.23-6.77 47.12-19.87l445.45-437.95c16.44-16.25 24-33.41 24-54.18 0-21.22-7.56-37.93-24-54.18z"
  })));
}
export default SvgArrow;